import _ from 'lodash';

export const customDatesParser = (campaings: any[]) => {
    const allStartDateAndCampaignPairs = campaings.map((c: any) => {
        return { startDate: c.periodStartDate, campaignName: 'C' + c.periodLabel.split('C')[1] };
    });

    const result: any = {};

    allStartDateAndCampaignPairs?.forEach((d: any) => {
        const day = new Date(d.startDate);
        const key = day.getMonth() + 1;
        const item = {
            month: day.getMonth() + 1,
            day: day.getDate(),
            date: new Date(day.getTime()),
            campaign: d.campaignName,
        };

        if (result[key]) {
            result[key].push(item);
        } else {
            result[key] = [item];
        }
    });

    return result;
};
